import { makeStyles, tokens } from '@fluentui/react-components';

import type { FluentV2CssGlobalValue } from './types';

/**
 * Collapse panel V2 overrides for the Budget step in PMax Lite.
 * Applied at the PMax Lite bundle level to avoid affecting other
 * consumers of the shared BudgetStepShell.
 */
export const useBudgetStepOverrides = makeStyles({
  root: {
    '& .collapse-container': {
      gap: '16px',
    },
    '& .collapse-panel': {
      padding: '0 !important',
      borderRadius: `${tokens.borderRadiusLarge} !important`,
      marginBottom: '0px !important',
      backgroundColor: `${tokens.colorNeutralBackground1} !important`,
      boxShadow: `${tokens.shadow4} !important`,
    },
    '& .collapse-panel .helpbutton::before': {
      verticalAlign: 'initial',
    },
    '& .collapse-panel .collapse-title-bar': {
      flexFlow: 'row wrap !important',
      padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXXL} !important`,
      minHeight: 'unset !important',
    },
    '& .collapse-panel.collapse-fixed-panel .collapse-title-bar': {
      paddingBottom: '0 !important',
    },
    '& .collapse-panel.collapse-fixed-panel .title-item': {
      width: 'auto !important',
      maxWidth: '100% !important',
    },
    '& .collapse-panel:not(.collapse-fixed-panel):not(.isCollapse) .collapse-title-bar': {
      borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2} !important`,
    },
    '& .collapse-panel:not(.collapse-fixed-panel) .collapse-title-bar .title-item': {
      width: 'calc(100% - 18px) !important',
    },
    '& .collapse-panel:not(.collapse-fixed-panel) .collapse-title-bar .error-string-wrapper': {
      position: 'unset !important' as unknown as FluentV2CssGlobalValue,
      marginTop: `${tokens.spacingVerticalS} !important`,
      width: '100% !important',
    },
    '& .collapse-panel:not(.collapse-fixed-panel) .collapse-title-bar .toggle-icon': {
      fontSize: '18px !important',
    },
    '& .collapse-panel .collapse-content': {
      padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXXL} !important`,
      marginBottom: '0 !important',
    },
    '& .collapse-panel .collapse-content.content-hide': {
      padding: '0 !important',
    },
    '& .collapse-panel .collapse-content-details': {
      padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXXL} !important`,
    },
  },
});
